<template>
  <div>
    <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
      <el-form-item label="套餐系列：">
        <el-input v-model.trim="searchForm.name" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>
      
      <el-form-item label="商品名称：">
        <el-input v-model.trim="searchForm.shareName" placeholder="支持模糊搜索" clearable></el-input>
      </el-form-item>
      <el-form-item label="商品设置：">
        <el-select v-model="searchForm.isHaveShop" clearable>
          <el-option label="未设置商品" value="0"></el-option>
          <el-option label="已设置商品" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="余额限制：">
        <el-select v-model="searchForm.type" clearable>
          <el-option label="不限制" value="0"></el-option>
          <el-option label="限制余额" value="1"></el-option>
          <el-option label="限制余额并且开户预存" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" plain icon="el-icon-search" @click="getPkgGroupListPageHandle">搜索</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="showAddPkgGroup">新建系列</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
      :header-cell-style="{ background: '#f5f5f5' }">
      <el-table-column prop="name" label="系列名称" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="typeName" label="余额限制" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isNextMonthName" label="跨月类型" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="xuliangName" label="虚量设置" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stateName" label="状态" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="subId" label="商户号" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isDownNAme" label="自动续费" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isAuthName" label="实名限制" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="isMiaoName" label="秒反类型" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center" width="390">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="showYu(scope.row)">余额参数</el-button>
          <el-button type="text" size="small" @click="pagePkgGroup(scope.row)">页面配置</el-button>
          <el-button type="text" size="small" @click="sharePkgGroup(scope.row)">购卡配置</el-button>
          <!-- <el-button type="text" size="small" @click="sharePkgGroup11(scope.row)">推送配置</el-button> -->
          <el-button type="text" size="small" @click="subGroup(scope.row)">商户配置</el-button>
          <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">
            <span style="color: red;">
              {{ showbtnText(scope.row.state) }}
            </span>
          </el-button>
          <el-button type="text" style="color: red;" size="small" @click="deleteGroupId(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
      layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
    </el-pagination>
    <el-dialog :append-to-body="true" :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel"
      :close-on-click-modal="false">
      <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
        <el-form-item label="套餐组名称：" prop="name">
          <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="余额限制：" prop="type">
          <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
            <el-option v-for="item in isPriceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="余额购买参数：" prop="priceData">
          <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="是否跨月：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
            <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="套餐类型：" prop="isNextMonth">
          <el-select v-model="addOrEditGroupForm.isVoice" placeholder="请选择">
            <el-option v-for="item in isVoiceOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="秒反设置：" prop="isMiao">
          <el-select v-model="addOrEditGroupForm.isMiao" placeholder="请选择">
            <el-option v-for="item in isMiaoList" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="addOrEditGroupForm.isMiao > 0" label="秒反金额/元：" prop="miaoPrice">
          <el-input v-model.trim="addOrEditGroupForm.miaoPrice" placeholder="后续降低秒反金额，需要重新给代理商！" clearable></el-input>
        </el-form-item>

        <el-form-item label="实名跳转：" prop="poolName">
          <el-input v-model.trim="addOrEditGroupForm.poolName" placeholder="(选填,如果选了 则优先套餐系列设置的实名链接)"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="微信弹窗内容：" prop="remark">
          <el-input v-model.trim="addOrEditGroupForm.remark" placeholder="将会在微信套餐页面进行弹窗提示" clearable></el-input>
        </el-form-item>


        <!-- <el-form-item label="自动续费：" prop="">
          <el-radio-group v-model="addOrEditGroupForm.isDown">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item label="实名限制：" prop="isAuth">
          <el-radio-group v-model="addOrEditGroupForm.isAuth">
            <el-radio :label="1">无限制</el-radio>
            <el-radio :label="0">先套餐后实名</el-radio>
            <el-radio :label="2">先实名后买套餐</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="绑定手机号：">
          <el-select v-model="addOrEditGroupForm.isBindPhone" placeholder="请选择">
            <el-option v-for="item in bindOption" :value="item.code" :key="item.description"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="限制绑定次数：" prop="bindSize" v-if="addOrEditGroupForm.isBindPhone == 2">
          <el-input v-model.trim="addOrEditGroupForm.bindSize" placeholder="限制一个手机号最多绑定几个卡号" clearable></el-input>
        </el-form-item>


        <el-form-item label="限速规则：">
          <el-select v-model="addOrEditGroupForm.limitId" clearable filterable>
            <el-option v-for="item in branchSupplierOption" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="阶梯虚量：">
          <el-select v-model="addOrEditGroupForm.xuliangId" clearable filterable>
            <el-option v-for="item in branchSupplierOptions" :value="item.code" :key="item.code"
              :label="item.description"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="无次月停机：" prop="stopDay">
          <el-input v-model.trim="addOrEditGroupForm.stopDay" placeholder="当套餐的最大有效期小于多少天时，开始停机。 时间大于0"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="日限额：" prop="dayLimitData">
          <el-input v-model.trim="addOrEditGroupForm.dayLimitData" placeholder="当日真实使用多少GB时，进行停机。次日恢复"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="月限额：" prop="monthLimitData">
          <el-input v-model.trim="addOrEditGroupForm.monthLimitData" placeholder="当月真实使用多少GB时，进行停机。次月恢复(不支持跨月)"
            clearable></el-input>
        </el-form-item>



        <el-form-item label="代理修改售价：" prop="isUpdate">
          <el-radio-group v-model="addOrEditGroupForm.isUpdate">
            <el-radio :label="1">不允许修改</el-radio>
            <el-radio :label="0">允许需改</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="是否允许停机：" prop="noStop">
          <p style="color:red;">此处一般选允许停机，不允许停机 轮询则只同步状态 </p>
          <el-radio-group v-model="addOrEditGroupForm.noStop">
            <el-radio :label="1">不允许停机</el-radio>
            <el-radio :label="0">允许停机</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="用户自选备注：" prop="groupRemark">
          <el-input v-model.trim="addOrEditGroupForm.groupRemark" placeholder="用户自选套餐系列时 展示给用户的备注（选填）"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="设备多网实名：" prop="allAuth">
          <el-radio-group v-model="addOrEditGroupForm.allAuth">
            <el-radio :label="1">设备多网实名</el-radio>
            <el-radio :label="0">普通实名</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <p style="color:red">配置商户号后 套餐系列的卡将会单独使用此商户收款</p>
        <el-form-item label="商户号：" prop="subId">
          <el-input v-model.trim="addOrEditGroupForm.subId" placeholder="微信商户号（选填）" clearable></el-input>
        </el-form-item>
        <el-form-item label="商户密钥：" prop="subKey">
          <el-input v-model.trim="addOrEditGroupForm.subKey" placeholder="微信商户密钥（选填）" clearable></el-input>
        </el-form-item> -->

      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="danger" @click="showYue">查询余额参数示列</el-button> -->
        <el-button @click="cancel">取 消</el-button>
        <el-button type="success" plain icon="el-icon-plus" @click="addOrEidtGroupHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :append-to-body="true" title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1"
      :close-on-click-modal="false">
      <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：最多只支持6个参数，amount代表充值金额/元
        giftBalance表示赠送金额/元。请修改后完整输入此参数</div>
      <div style="text-align: center; width:100%;">
        <p alt="" style="margin: 0 auto;">{{ urls }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="shareGroup" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品展示图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img :src="getImgUrl() + shareForm.shareImg" alt="" width="150" height="150" />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareName" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareType" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.sharePrice" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareYongjing" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareTypeOrderBy" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input v-model.trim="shareForm.shareShopOrderBY" placeholder="选填（数字越大排序越靠前）" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="autoFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="updateAuto" :model="updateAuto" label-width="120px">
        <p style="color:red">仅仅支持自运营流量池的卡。卡当前套餐使用完后 可用余额自动购买绑定的套餐</p>

        <el-form-item label="续费套餐编码:" prop="autoState">
          <el-col :span="22">
            <el-input v-model.trim="updateAuto.autoPkgId" placeholder="流量超套后 将会自动用余额续费此套餐" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="续费状态：" prop="autoState">
          <el-radio-group v-model="updateAuto.autoState">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="updateAutoSure()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :append-to-body="true" class="formDialog" title="推送配置" :visible.sync="pushFlg" width="600px"
      @close="cancel12" :close-on-click-modal="false">
      <el-form ref="pushData" :model="pushData" label-width="120px">
        <el-form-item label="套餐预警推送：" prop="wxMsgState">
          <el-radio-group v-model="pushData.wxMsgState">
            <el-radio :label="0">开启</el-radio>
            <el-radio :label="1">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="套餐购买推送：" prop="wxPkgMsgState">
          <el-radio-group v-model="pushData.wxPkgMsgState">
            <el-radio :label="0">关闭推送</el-radio>
            <el-radio :label="2">购套餐推送</el-radio>
            <el-radio :label="1">仅首充推送</el-radio>
          </el-radio-group>
        </el-form-item>
        <p style="color:red">上面是微信推送配置，下面是短信配置推送。 互不关联</p>
        <el-form-item label="短信推送模板ID:" prop="smsMsgId">
          <el-col :span="22">
            <el-input v-model.trim="pushData.smsMsgId" placeholder="不填，则不进行短信推送" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="短信到期日期:" prop="smsMsgDay">
          <el-col :span="22">
            <el-input v-model.trim="pushData.smsMsgDay" placeholder="填5则到期第五天发送短信通知。多个日期，逗号隔开" clearable></el-input>
          </el-col>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle11">确 定</el-button>
      </div>
    </el-dialog>










    <el-dialog :append-to-body="true" class="formDialog" title="页面配置" :visible.sync="isShowPage" width="600px"
      @close="pageCancel" :close-on-click-modal="false">
      <el-form ref="pageData" :model="pageData" label-width="120px">
        <el-form-item label="活动页面：" prop="isNewPage">
          <el-radio-group v-model="pageData.isNewPage">
            <el-radio :label="0">经典充值页面</el-radio>
            <el-radio :label="2">快捷直充页面</el-radio>
            <el-radio :label="1">简洁大气页面</el-radio>
            <el-radio :label="3">设备管理页面</el-radio>
          </el-radio-group>
        </el-form-item>
        <p style="color:red" v-if="pageData.isNewPage == 1">选填：不填则系统默认购卡宣传图和跳转链接</p>
        <el-form-item label="活动图(像素644*200)：" v-if="pageData.isNewPage == 1">
          <input type="file" ref="file3" placeholder="">
          <img :src="getImgUrl() + pageData.newHomePcImg" alt="" width="300" height="100">
        </el-form-item>

        <el-form-item label="点击跳转链接:" prop="newHomeUrl" v-if="pageData.isNewPage == 1">
          <el-col :span="22">
            <el-input v-model.trim="pageData.newHomeUrl" placeholder="选填，默认跳转购卡页面。 或填第三方跳转链接" clearable></el-input>
          </el-col>
        </el-form-item>


        <p style="color:red" v-if="pageData.isNewPage == 2">选填：不上传则不进行弹窗</p>
        <el-form-item label="弹窗二维码(像素350*350)：" v-if="pageData.isNewPage == 2">
          <input type="file" ref="file4" placeholder="">
          <img :src="getImgUrl() + pageData.newHomePcImg2" alt="" width="350" height="350">
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pageCancel">取 消</el-button>
        <el-button type="primary" @click="sureToPage">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog :append-to-body="true" class="formDialog" :title="title" :visible.sync="subFlg" width="600px"
      @close="cancelSub" :close-on-click-modal="false">
      <p style="color:red">配置商户号后 套餐系列的卡将会单独使用此商户收款</p>
      <el-form ref="subData" :model="subData" label-width="120px">
        <el-form-item label="商户类型：" prop="subType">
          <el-radio-group v-model="subData.subType">
            <el-radio :label="20">微信支付</el-radio>
            <el-radio :label="50">乐刷支付</el-radio>
            <el-radio :label="62">易支付</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="微信商户号:" prop="subId" v-if="subData.subType == 20">
          <el-col :span="22">
            <el-input v-model.trim="subData.subId" placeholder="商户号须和公众号进行绑定" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信商户密钥:" prop="subKey" v-if="subData.subType == 20">
          <el-col :span="22">
            <el-input v-model.trim="subData.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷商户编号:" prop="subId" v-if="subData.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="subData.subId" placeholder="乐刷商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷支付密钥:" prop="subKey" v-if="subData.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="subData.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="乐刷回调密钥:" prop="subPwd" v-if="subData.subType == 50">
          <el-col :span="22">
            <el-input v-model.trim="subData.subPwd" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="商户编号:" prop="subId" v-if="subData.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="subData.subId" placeholder="商户号" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商户密钥:" prop="subKey" v-if="subData.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="subData.subKey" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="支付域名:" prop="subPwd" v-if="subData.subType == 62">
          <el-col :span="22">
            <el-input v-model.trim="subData.subPwd" placeholder="必选" clearable></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSub">取 消</el-button>
        <el-button type="primary" @click="sureSub">确 定</el-button>
      </div>
    </el-dialog>





    <!---方案弹窗-->
    <el-dialog :append-to-body="true" title="充值余额参数" :visible.sync="showYuFlg" width="600px"
      :close-on-click-modal="false">
      <el-form ref="showYuData" :model="showYuData" label-width="120px">
        <el-form-item label="余额规则：" prop="limitDatalist">
          <div style="font-size:12px;color:red;">请按照充值金额从小到大排序。赠送金额没有请填0</div>

          <template v-if="showYuData.limitDatalist">
            <el-row v-for="(k, index) in showYuData.limitDatalist" :key="index" style="margin-bottom:10px">
              <el-col :span="10" style="padding-right:5px;">
                <el-input v-model="k.amount" placeholder="充值余额" clearable @input="change($event)" />
              </el-col>
              <el-col :span="10" style="padding-right:5px;">
                <el-input v-model="k.giftBalance" placeholder="赠送余额" clearable @input="change($event)" />
              </el-col>
              <el-col :span="10" style="padding-right:5px;">
                <el-input v-model="k.title" placeholder="备注" clearable @input="change($event)" />
              </el-col>
              <el-col :span="10" style="padding-right:5px;">
                <el-radio-group v-model="k.type">
                  <el-radio :label="1">推荐</el-radio>
                  <el-radio :label="0">不推荐</el-radio>
                </el-radio-group>
              </el-col>

              <el-col :span="4">
                <el-button type="danger" @click="delRule(index)">删除</el-button>
              </el-col>
            </el-row>
          </template>
          <el-button type="primary" @click="addRule">新增规则</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelYu()">取 消</el-button>
        <el-button type="primary" @click="sumbit()">提 交</el-button>
      </div>
    </el-dialog>



  </div>
</template>
<script>
import { getPkgGroupListPage, addPkgGroup, updatePkgGroup, changePkgGroupState, getPkgIsMonthOption } from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
  data() {
    return {
      bindOption: [
        {
          code: 1,
          description: '无需绑定'
        },
        {
          code: 2,
          description: '绑定手机号'
        },
        {
          code: 3,
          description: '绑定手机号+上传身份证'
        }
      ],
      pushData: {
        id: '',
        smsMsgId: '',
        smsMsgDay: '',
        wxMsgState: '',
        wxPkgMsgState: ''
      },
      pushFlg: false,
      autoFlg: false,
      updateAuto: {
        id: '',
        autoState: '',
        autoPkgId: ''
      },
      existBackImg: false,
      shareGroup: false,
      existBackImg1: false,
      shareGroup1: false,
      shareGroup11: false,
      shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",

        shareType: '',
        shareYongjing: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

      },
      isMiaoList: [

        {
          code: 0,
          description: '不秒反'
        },
        {
          code: 1,
          description: '一次性秒反'
        },
        {
          code: 2,
          description: '一次性秒反+套餐秒反'
        }
      ],
      urls: '',
      shareImgs: false,
      searchForm: {
        name: '',
        isVoice: '',



        isNextMonth: ''
      },
      tbpg: {
        tableData: [],
        currentPage: 1,
        pageSize: 15,
        total: 0,
      },
      addOrEditGroupForm: {
        isBindPhone: '',
        stopDay: '',
        name: '',
        type: '',
        isAuth: '',
        subId: '',
        subKey: '',
        isNextMonth: '',
        supplierType: '1',
        remark: '',
        isDown: '',
        limitId: '',
        bindSize: '',
        xuliangId: '',
        priceData: '',
        stopData: '',
        shareType: '',
        shareYongjing: '',
        miaoPrice: '',
        isMiao: '',
        sharePrice: '',
        shareTypeOrderBy: '',
        shareShopOrderBY: '',

        poolName: '',
        isVoice: '',

        newHomeImg: '',
        isNewPage: '',
        newHomeUrl: '',
        newHomeImg2: '',

        subPwd: '',
        subType: '',
        isUpdate: '',
        noStop: '',
        monthLimitData: '',
        dayLimitData: '',

        groupRemark:'',
        allAuth:'',
      },
      branchSupplierOption: [],
      branchSupplierOptions: [],
      isPriceOption: [
        {
          code: 0,
          description: '不限制'
        },
        {
          code: 1,
          description: '限制余额'
        },
        {
          code: 2,
          description: '限制余额并且开户预存'
        }
      ],
      isVoiceOption: [
        {
          code: 0,
          description: '流量'
        },
        {
          code: 1,
          description: '流量+语音'
        }
      ],
      currentId: '',
      addFlag: null,
      addGroupVisibale: false,
      title: '',
      pkgTypeOption: [],
      supplierOption: [],
      isMonthOption: [],
      addOrEditGroupRules: {
        name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        isNextMonth: [{ required: true, message: '请选择套餐名称', trigger: 'change' }],
        supplierType: [{ required: true, message: '请选择套餐名称', trigger: 'change' }]
      },

      pageData: {
        id: '',
        newHomeUrl: '',
        newHomePcImg: '',
        newHomePcImg2: '',
        isNewPage: ''
      },
      isShowPage: false,


      subFlg: false,
      subData: {
        subId: '',
        subKey: '',
        subType: '',
        subPwd: '',
        id: ''
      },


      showYuFlg: false,
      showYuData: {
        limitDatalist: [],
        id: '',
        listString: '' // limitData转String
      }


    }
  },
  methods: {
    change(e) {
      this.$forceUpdate()
    },
    showYu(row) {
      this.showYuData.id = row.id;
      if (row.priceData) {
        this.showYuData.limitDatalist = JSON.parse(row.priceData)
      } else {
        this.showYuData.limitDatalist = [];
      }
      this.showYuFlg = true;
    },
    cancelYu() {
      this.showYuFlg = false;
    },
    //弹窗新增规则
    addRule() {
      this.showYuData.limitDatalist.push({
        amount: '',
        giftBalance: '',
        title: '',
        type: ''
      })
      this.$forceUpdate()
    },
    //弹窗删除规则
    delRule(i) {
      this.showYuData.limitDatalist = this.showYuData.limitDatalist.filter((item, index) => index !== i)
      this.$forceUpdate()
    },
    //保存
    sumbit() {
      this.$refs['showYuData'].validate((valid) => {
        if (valid) {
          var size = this.showYuData.limitDatalist.length > 0 ? this.showYuData.limitDatalist.filter(item => !item.amount) : []
          if (this.showYuData.limitDatalist.length === 0 || size.length > 0) {
            this.$message.error('余额规则有未填项，请补充完整后提交');
            return
          }
          var data = {
            id: this.showYuData.id,
            stringData: this.showYuData.limitDatalist
          }
          common.sysRequest("pkg/update/yu/data", data, "post").then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.message);
              this.getPkgGroupListPageHandle();
              this.cancelYu();
            } else {
              this.$message.error(res.data.message);
            }
          })
            .catch((err) => console.error(err));

        }
      })
    },



    cancelSub() {
      this.subFlg = false
    },
    subGroup(row) {
      this.subData.subId = row.subId;
      this.subData.subKey = row.subKey;
      this.subData.subType = row.subType;
      this.subData.subPwd = row.subPwd;
      this.subData.id = row.id;
      this.subFlg = true;
    },
    sureSub() {
      common
        .sysRequest("pkg/group/insert/wx/config", this.subData, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.subFlg = false;
            this.getPkgGroupListPageHandle();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

    },



    deleteGroupId(id) {
      this.$confirm("此操作会把套餐系列和系列下面的套餐全部删除。确定要操作吗？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var data = { id: id }
        common.sysRequest("pkg/group/delete/group", data, "post").then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
          .catch((err) => console.error(err));
      })

    },


    pageCancel() {
      this.isShowPage = false;
    },
    pagePkgGroup(row) {
      this.pageData.id = row.id;
      this.pageData.newHomePcImg = row.newHomeImg;
      this.pageData.newHomePcImg2 = row.newHomeImg2;
      this.pageData.newHomeUrl = row.newHomeUrl;
      this.pageData.isNewPage = row.isNewPage;
      this.isShowPage = true;
    },
    sureToPage() {
      let fd = new FormData();

      Object.keys(this.pageData).forEach((key) => {
        fd.append(key, this.pageData[key]);
      });
      if (this.pageData.isNewPage == 1) {
        fd.append("pageUrl", this.$refs.file3.files[0]);
      } else if (this.pageData.isNewPage == 2) {
        fd.append("pageUrl2", this.$refs.file4.files[0]);
      }
      common
        .sysRequest("pkg/group/page/type", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            if (this.pageData.isNewPage == 1) {
              this.$refs.file3.value = "";
            } else if (this.pageData.isNewPage == 2) {
              this.$refs.file4.value = "";
            }
            this.getPkgGroupListPageHandle();
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.isShowPage = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }

    },



    sharePkgGroup11(row) {
      this.pushData.id = row.id;
      this.pushData.wxMsgState = row.wxMsgState;
      this.pushData.smsMsgDay = row.smsMsgDay;
      this.pushData.smsMsgId = row.smsMsgId;
      this.pushData.wxPkgMsgState = row.wxPkgMsgState;
      this.pushFlg = true;
    },
    addOrEidtPkgHandle11() {
      common.sysRequest("pkg/group/update/push/info", this.pushData, "post").then((res) => {
        if (res.data.code == 200) {
          this.getPkgGroupListPageHandle();
          this.pushFlg = false;
          this.$message.success(res.data.message);

        } else {
          this.$message.error(res.data.message);
        }
      })
        .catch((err) => console.error(err));
    },



    updateAutoSure() {
      common.sysRequest("pkg/group/update/auto/pkg", this.updateAuto, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.autoFlg = false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },
    updateAutoState(row) {
      this.updateAuto.id = row.id;
      this.updateAuto.autoPkgId = row.autoPkgId;
      this.updateAuto.autoState = row.autoState;
      this.autoFlg = true;
    },
    addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file1.value = "";
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    cancel12() {
      this.pushFlg = false;
      this.autoFlg = false;
      this.shareGroup = false;
      this.existBackImg1 = false;
      this.shareGroup1 = false;
      this.shareGroup11 = false;
      this.$refs.shareForm.resetFields();
    },
    sharePkgGroup(row) {

      this.shareForm.shareType = row.shareType;
      this.shareForm.sharePrice = row.sharePrice;
      this.shareForm.shareYongjing = row.shareYongjing;
      this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.shareForm.shareShopOrderBY = row.shareShopOrderBY;

      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.existBackImg = true;
      this.shareGroup = true;
    },
    //复制功能
    copy() {
      var clipboard = new Clipboard('.copy_url')
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        this.shareImgs = false;
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message.success('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },
    showYue() {
      this.urls = '[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
      this.shareImgs = true;
    },
    cancel() {
      this.shareImgs = false;
      this.addGroupVisibale = false;
      this.$refs.addOrEditGroupForm.resetFields();
    },
    cancel1() {
      this.shareImgs = false;
    },
    showbtnText(state) {
      return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
    },
    getPkgGroupListPageHandle($event) {
      common.resetCurrentPage(this, $event, 'tbpg');
      var data = common.getRequestParams(this, 'tbpg', this.searchForm);
      getPkgGroupListPage(data).then(res => {
        common.listCallback(this, res, 'tbpg');
      })
    },
    showAddPkgGroup() {
      this.addGroupVisibale = true;
      this.addFlag = true;
      this.title = "新增套餐组";
      this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
    },
    showEditPkgGroup(row) {
      this.addGroupVisibale = true;
      this.addFlag = false;
      this.title = "修改套餐组";
      this.addOrEditGroupForm.groupRemark = row.groupRemark;
      this.addOrEditGroupForm.allAuth = row.allAuth;
      this.addOrEditGroupForm.monthLimitData = row.monthLimitData;
      this.addOrEditGroupForm.dayLimitData = row.dayLimitData;

      this.addOrEditGroupForm.noStop = row.noStop;
      this.addOrEditGroupForm.subType = row.subType;
      this.addOrEditGroupForm.subPwd = row.subPwd;
      this.addOrEditGroupForm.isUpdate = row.isUpdate;

      this.addOrEditGroupForm.newHomeImg2 = row.newHomeImg2;
      this.addOrEditGroupForm.newHomeImg = row.newHomeImg;
      this.addOrEditGroupForm.newHomeUrl = row.newHomeUrl;
      this.addOrEditGroupForm.isNewPage = row.isNewPage;

      this.addOrEditGroupForm.bindSize = row.bindSize;

      this.addOrEditGroupForm.isBindPhone = row.isBindPhone;
      this.addOrEditGroupForm.stopDay = row.stopDay;

      this.addOrEditGroupForm.shareType = row.shareType;
      this.addOrEditGroupForm.isMiao = row.isMiao;
      this.addOrEditGroupForm.miaoPrice = row.miaoPrice;
      this.addOrEditGroupForm.shareYongjing = row.shareYongjing;
      this.addOrEditGroupForm.subId = row.subId;
      this.addOrEditGroupForm.subKey = row.subKey;
      this.addOrEditGroupForm.sharePrice = row.sharePrice;
      this.addOrEditGroupForm.shareTypeOrderBy = row.shareTypeOrderBy;
      this.addOrEditGroupForm.shareShopOrderBY = row.shareShopOrderBY;
      this.addOrEditGroupForm.stopData = row.stopData;
      this.addOrEditGroupForm.isAuth = row.isAuth;
      this.addOrEditGroupForm.limitId = row.limitId;
      this.addOrEditGroupForm.xuliangId = row.xuliangId;
      this.addOrEditGroupForm.name = row.name;
      this.addOrEditGroupForm.type = row.type;
      this.addOrEditGroupForm.isVoice = row.isVoice;
      this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
      this.addOrEditGroupForm.supplierType = row.supplierType;
      this.addOrEditGroupForm.remark = row.remark;
      this.addOrEditGroupForm.poolName = row.poolName;
      this.addOrEditGroupForm.priceData = row.priceData;
      this.currentId = row.id;
      this.addOrEditGroupForm.isDown = row.isDown;
    },
    addOrEidtGroupHandle() {
      this.$refs.addOrEditGroupForm.validate(valid => {
        if (valid) {
          var data = this.addOrEditGroupForm;
          if (this.addFlag == true) {
            addPkgGroup(data).then(res => callback(res))
          } else {
            data.id = this.currentId
            updatePkgGroup(data).then(res => callback(res))
          }
        }
        var _this = this;
        function callback(res) {
          if (res.data.code == 200) {
            _this.getPkgGroupListPageHandle();
            _this.addGroupVisibale = false;

          } else {
            _this.$message.error(res.data.message)
          }
        }
      })
    },
    changeStateHandle(id) {
      var data = {
        id
      }
      changePkgGroupState(data).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message)
          this.getPkgGroupListPageHandle();
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getPkgGroupListPageHandle();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val
      this.getPkgGroupListPageHandle();
    }
  },
  created() {
    this.getPkgGroupListPageHandle();
    common.getPkgTypeOptionCom(this, 'pkgTypeOption');
    common.getSupplierOptionCom(this, 'supplierOption');
    common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
    common.getSupplierLimitOptionComs(this, 'branchSupplierOptions')
    getPkgIsMonthOption().then(res => {
      if (res.data.code == 200) {
        this.isMonthOption = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    })
  }
}
</script>
<style></style>
